import { render, staticRenderFns } from "./CrossDomainRules.vue?vue&type=template&id=3db6ed0f"
import script from "./CrossDomainRules.vue?vue&type=script&lang=js"
export * from "./CrossDomainRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports